import * as S from './styles';
import emojiSuccess from '../../../assets/image/successemoji.svg';
import {
  Emoji,
  CloseButton,
  AlertContent,
} from "../alertStyles"

const SuccessBaseCad = ({ open, onClose, alertText }) => {
  if (open)
    return (
      <S.AlertBox>
        <CloseButton onClick={onClose}>x</CloseButton>
        <Emoji src={emojiSuccess} alt="Emoji Description" />
        <S.AlertTitle>Base do CadÚnico atualizada com sucesso!</S.AlertTitle>
      </S.AlertBox>
    );
};

export default SuccessBaseCad;
